import * as React from 'react';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { List } from 'office-ui-fabric-react/lib/List';
import { SearchResultsItem, SearchResultItemData } from './search-results-item';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import axios from 'axios'
import { translation as _t } from '../util/translations';

export class Search extends React.Component<any, any> {

    constructor(props, context) {
        super(props, context);
        this.state = {
            items: []
        };
    }

  public render() {
    return (
        <div className="search-container ms-bgColor-neutralLighter">
        <div className="search-box-container">

        <SearchBox
        labelText={_t('search')}
        className="ms-bgColor-white"
        onChange={(val) => {
            if (val.length < 3) {
                return
            }
            // console.log('on change', window.fetch)
            axios.post('https://zefix.lexsear.ch/ZefixREST/api/v1/firm/search.json', {
                maxEntries: 15,
                name: val,
                offset: 0,
                searchType: 'exact',
                deletedFirms: true,
                formerNames: true
            })
                .then((response) => {
                    var entries = response.data.list.map((entry) => {
                        let uidParts = entry.uid.match(/.{1,3}/g);
                        let uid = uidParts ? `${uidParts[0]}-${uidParts[1]}.${uidParts[2]}.${uidParts[3]}` : '';
                        return {
                            name: entry.name,
                            legalSeat: entry.legalSeat,
                            ehraid: entry.ehraid,
                            uid: uid,
                            chid: entry.chid,
                            status: entry.status
                        }
                    })
                    this.setState({ items: entries })
                })
                .catch((e) => {
                    console.log('error', e)
                    this.setState({ items: [] })
                })
        }}
        onClear={() => {
            this.setState({ items: [] })
        }}
      />
      </div>
      <FocusZone className="ms-content-wrapper" direction={ FocusZoneDirection.vertical }>
      <List
        className='ms-ListBasicExample-list'
        items={ this.state.items }
        onRenderCell={ this._onRenderCell }
      />
      </FocusZone>
      </div>
    );
  }

  private _onRenderCell(item: SearchResultItemData, index: number | undefined): JSX.Element {
    return (
        <SearchResultsItem data={item} index={index} key={item.uid}></SearchResultsItem>
    );
  }

}



// WEBPACK FOOTER //
// ./components/search.tsx